import { Method } from '@rxap/utilities';
import { OpenApiMethod, HttpMethods, OpenApiParameterType, BaseOpenApiMethod } from '../../open-api.method';
import { AssignmentControllerGetUnassignedParameter } from '../../parameters/assignment-controller-get-unassigned.parameter';
import { AssignmentControllerGetUnassignedResponse } from '../../responses/assignment-controller-get-unassigned.response';

interface AssignmentControllerGetUnassignedOpenApiParameters {
  parameters: AssignmentControllerGetUnassignedParameter;
}

@OpenApiMethod({
  method: HttpMethods.GET,
  apiName: 'customer',
  path: '/assignment/unassigned/{year}/{month}/{day}',
  operationId: 'AssignmentController_getUnassigned',
  parameters: [
    {
      name: 'year',
      required: true,
      in: OpenApiParameterType.PATH,
    },
    {
      name: 'month',
      required: true,
      in: OpenApiParameterType.PATH,
    },
    {
      name: 'day',
      required: true,
      in: OpenApiParameterType.PATH,
    },
    {
      name: 'byDate',
      required: false,
      in: OpenApiParameterType.QUERY,
    },
    {
      name: 'cities',
      required: true,
      in: OpenApiParameterType.QUERY,
    },
  ],
})
export class AssignmentControllerGetUnassignedMethod
  extends BaseOpenApiMethod<AssignmentControllerGetUnassignedResponse>
  implements Method<AssignmentControllerGetUnassignedResponse, AssignmentControllerGetUnassignedOpenApiParameters>
{
  public call(parameters: AssignmentControllerGetUnassignedOpenApiParameters): Promise<AssignmentControllerGetUnassignedResponse> {
    return super.call(parameters);
  }
}
